// extracted by mini-css-extract-plugin
module.exports = {"mdh459d":"mdh459d"};